import _ from 'underscore';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ListSelector } from '@bingads-webui-react/list-selector';

export class FeedSelectorView extends Component {
  static defaultProps = {
    feeds: [],
  };

  renderItem = (item) => {
    const { i18n } = this.props;
    const { Name, AttributeNames, Description } = item;
    let attributeDescription = '';

    if (Description && Description.length > 0) {
      attributeDescription = Description;
    } else {
      const processAttributeNames = _.first(AttributeNames, 3);

      if (AttributeNames.length > 3) {
        processAttributeNames.push('...');
      }
      const attributeDescriptionPre = i18n.getString('Feeds_FeedItemsPage_Attributes_Description');
      attributeDescription = `${attributeDescriptionPre}${processAttributeNames.join(', ')}`;
    }

    return (
      <div className="feed-with-attributes">
        <h2 className="feed-name">{Name}</h2>
        <div className="type5 feed-attribute-description">{attributeDescription}</div>
      </div>);
  };

  render() {
    const { feeds, onSelect } = this.props;
    return (
      <div className="feed-selector">
        <ListSelector
          renderItem={this.renderItem}
          onSelect={onSelect}
          data={feeds}
        />
      </div>
    );
  }
}

FeedSelectorView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  feeds: PropTypes.arrayOf(PropTypes.shape({
    Name: PropTypes.string,
    AttributeNames: PropTypes.arrayOf(PropTypes.string),
    Id: PropTypes.number,
  })),
  onSelect: PropTypes.func.isRequired,
};
